import { IonContent, IonFooter, IonToolbar } from '@ionic/react';
import PaymentCoordinator from '../../../../components-library/payment/PaymentCoordinator';
import PageHeader from '../../components/headers/PageHeader';
import { useTranslation } from 'react-i18next';
import CheckoutButton from '../../../../components-library/buttons/CheckoutButton';
import { ReactElement } from 'react';
import PayButton from '../../../../components-library/payment/buttons/PayButton';
import OrderPaymentScreen from '../../../../pages/checkout/OrderPaymentScreen';
import useDraftError from '../../../../hooks/order/useDraftError';

const Content = (): ReactElement => {
  // The footer is a sibling of the screen, so the screen's own early return to
  // OrderDraftErrorPage would leave a Pay button floating over — or trapped under —
  // a full-screen error for an order that does not exist. Same hook, same options as
  // OrderPaymentScreen, so the two cannot disagree about when that happens.
  const { show: showDraftError } = useDraftError();

  if (showDraftError) {
    return <OrderPaymentScreen className="pb-[230px]" />;
  }

  return (
    <>
      <OrderPaymentScreen className="pb-[230px]" />
      <IonFooter className="">
        <IonToolbar className="ion-color !p-0 [&::part(container)]:p-0 bg-white fixed bottom-0 w-full safe-area-bottom">
          <CheckoutButton>
            <PayButton />
          </CheckoutButton>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

const OrderPaymentPage = (): ReactElement => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:CheckoutPage' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent className="safe-area-bottom">
        <PaymentCoordinator>
          <Content />
        </PaymentCoordinator>
      </IonContent>
    </>
  );
};

export default OrderPaymentPage;
